const ClientRepository = {
    GET_PROJECT_NAME: "GET_PROJECT_NAME",
    GET_PROJECT_NAME_LOADING: "GET_PROJECT_NAME_LOADING",
    GET_PROJECT_NAME_SUCCESS: "GET_PROJECT_NAME_SUCCESS",
    GET_PROJECT_NAME_RESET: "GET_PROJECT_NAME_RESET",
    GET_PROJECT_NAME_ERROR: "GET_PROJECT_NAME_ERROR",
    
    UPLOAD_PROJECT_DETAIL: "UPLOAD_PROJECT_DETAIL",
    UPLOAD_PROJECT_DETAIL_LOADING: "UPLOAD_PROJECT_DETAIL_LOADING",
    UPLOAD_PROJECT_DETAIL_SUCCESS: "UPLOAD_PROJECT_DETAIL_SUCCESS",
    UPLOAD_PROJECT_DETAIL_RESET: "UPLOAD_PROJECT_DETAIL_RESET",
    UPLOAD_PROJECT_DETAIL_ERROR: "UPLOAD_PROJECT_DETAIL_ERROR",

    GET_UPLOAD_PROJECT_DETAIL: "GET_UPLOAD_PROJECT_DETAIL",
    GET_UPLOAD_PROJECT_DETAIL_LOADING: "GET_UPLOAD_PROJECT_DETAIL_LOADING",
    GET_UPLOAD_PROJECT_DETAIL_SUCCESS: "GET_UPLOAD_PROJECT_DETAIL_SUCCESS",
    GET_UPLOAD_PROJECT_DETAIL_RESET: "GET_UPLOAD_PROJECT_DETAIL_RESET",
    GET_UPLOAD_PROJECT_DETAIL_ERROR: "GET_UPLOAD_PROJECT_DETAIL_ERROR",
    
};

export default ClientRepository;
